import { render, staticRenderFns } from "./SendAssessmentLink.vue?vue&type=template&id=c1fb4c26&scoped=true&"
import script from "./SendAssessmentLink.vue?vue&type=script&lang=js&"
export * from "./SendAssessmentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fb4c26",
  null
  
)

export default component.exports